"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorType = exports.EntityType = void 0;
var EntityType;
(function (EntityType) {
    EntityType["ORDER"] = "ORDER";
    EntityType["PRODUCT"] = "PRODUCT";
    EntityType["INVENTORY"] = "INVENTORY";
    EntityType["INTEGRATION"] = "INTEGRATION";
})(EntityType = exports.EntityType || (exports.EntityType = {}));
var ErrorType;
(function (ErrorType) {
    ErrorType["ADDRESS_CHECK_ERROR"] = "ADDRESS_CHECK_ERROR";
    ErrorType["PRODUCT_IMPORT_ERROR"] = "PRODUCT_IMPORT_ERROR";
    ErrorType["DSKU_NEVER_INBOUNDED_ERROR"] = "DSKU_NEVER_INBOUNDED_ERROR";
    ErrorType["PRODUCT_CUSTOMS_ERROR"] = "PRODUCT_CUSTOMS_ERROR";
    ErrorType["PRODUCT_VALIDATION_ERROR"] = "PRODUCT_VALIDATION_ERROR";
    ErrorType["DUPLICATE_ORDER_ERROR"] = "DUPLICATE_ORDER_ERROR";
    ErrorType["ORDER_VALIDATION_ERROR"] = "ORDER_VALIDATION_ERROR";
    ErrorType["INVALID_COUNTRY_CODE_ERROR"] = "INVALID_COUNTRY_CODE_ERROR";
    ErrorType["UNKNOWN_ORDER_ERROR"] = "UNKNOWN_ORDER_ERROR";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
//# sourceMappingURL=BaseEventLog.js.map